import React from "react";
// import StarRatingComponent from "react-star-rating-component";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { shownText, toPersianNum, toSeperatedNum } from "../../assets/utils";
import {
  selectCurrentLoad,
  selectLoadBits,
} from "../../redux/load/load.selectors";
import UserProfile from "../../assets/img/profile.png";
import UserProfileVector from "../../assets/img/icn-user-drk.svg";
import {
  CardColored,
  Container,
  BitsSingleStyled,
  PriceStyled,
  BitsContainerStyled,
  UserInfoContainer,
  UserProfileImage,
} from "./ReqInfo.styles";
import Masonry from "react-masonry-css";
import BackBtn from "../../components/BackBtn/BackBtn.component";
import RateStar from "../../assets/img/Star.svg";
// import logo from "../../assets/img/logo.jpeg";

const ReqInfo = ({ currentLoad, selectLoadBits }) => {
  const SERVER_API = "https://barnet.app/";
  let {
    status,
    status_persian,
    source_location,
    destination_location,
    // request_type,
    // request_model,
    weight,
    weight_unit,
    loading_description,
    value,
    load_type,
    reuqested_date_persian,
    created_date_persian,
    vehicle_requested,

    Height,
    Length,
    Width,
  } = currentLoad;
  const breakpointColumnsObj = {
    default: 3,
    2300: 3,
    1750: 3,
    1450: 3,
    1280: 3,
    992: 2,
    600: 1,
  };
  // document.addEventListener("contextmenu", (event) => event.preventDefault());
  const Rating = (rank) => {
    switch (rank) {
      case 0:
        return (
          <>
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
          </>
        );
      case 1:
        return (
          <>
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
          </>
        );
      case 2:
        return (
          <>
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
          </>
        );
      case 3:
        return (
          <>
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
          </>
        );
      case 4:
        return (
          <>
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
          </>
        );
      case 5:
        return (
          <>
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
            <img src={RateStar} alt="star" style={{ margin: "2px" }} />
          </>
        );
      default:
        return (
          <>
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
            <img
              src={RateStar}
              alt="star"
              style={{ opacity: "0.4", margin: "2px" }}
            />
          </>
        );
    }
  };
  console.log(selectLoadBits);
  return (
    <div>
      <Container>
        <div className="d-flex flex-column flex-lg-row justify-content-between position-relative pl-lg-5">
          <CardColored status={status} className="shadow-sm py-3">
            <div>
              <span className="font-weight-bold font-size--2">{`${source_location._ostan.provincename}، ${source_location._shahr.shahrname}،`}</span>
              <span className="font-weight-lighter mr-2">
                {source_location.detail
                  ? shownText(source_location.detail)
                  : "نامشخص"}
              </span>
            </div>
            <div className="my-3">
              <span className="font-weight-bold font-size--2">{`${destination_location._ostan.provincename}، ${destination_location._shahr.shahrname}،`}</span>
              <span className="font-weight-lighter mr-2">
                {destination_location.detail
                  ? shownText(destination_location.detail)
                  : "نامشخص"}
              </span>
            </div>

            <div className="vehicle font-weight-bold font-size--1 text-center mb-3 mt-2">
              <span>
                {vehicle_requested ? vehicle_requested.v_name : "نامشخص"}
              </span>
            </div>

            <div
              className="text-center font-weight-bold"
              style={{ textDecoration: "underline" }}
            >
              <span>{status_persian ? status_persian : "نامشخص"}</span>
            </div>
          </CardColored>
          <div className="flex-grow-1 mr-0 p-4 align-self-lg-center">
            <div className="mb-2">
              <div className="border-bottom mb-2">
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  زمان درخواست
                </div>
                <div>
                  {reuqested_date_persian
                    ? toPersianNum(created_date_persian)
                    : "نامشخص"}
                </div>
              </div>
              <div className="border-bottom mb-2">
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  زمان بارگیری
                </div>
                <div>
                  {reuqested_date_persian
                    ? toPersianNum(reuqested_date_persian)
                    : "نامشخص"}
                </div>
              </div>
            </div>

            <div className="border-bottom d-flex align-items-center justify-content-between pb-1 mt-3">
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  بسته بندی
                </div>
                <div>
                  {load_type ? toPersianNum(load_type.tname) : "وارد نشده‌است"}
                </div>
              </div>
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  طول، عرض و ارتفاع
                </div>
                <div>
                  {Length ? <span> {toPersianNum(Length)} × </span> : null}

                  {Width ? <span> {toPersianNum(Width)} × </span> : null}

                  {Height ? <span> {toPersianNum(Height)} </span> : null}

                  {Height && Length && Width ? null : "وارد نشده"}
                </div>
              </div>
            </div>

            <div className="border-bottom border-0 d-flex align-items-center justify-content-between pb-1 mt-3">
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  وزن
                </div>
                <div>
                  {weight
                    ? `${toPersianNum(weight)} ${
                        weight_unit === "ton"
                          ? "تن"
                          : weight_unit === "kg"
                          ? "کیلوگرم"
                          : null
                      }`
                    : "وارد نشده‌است"}
                </div>
              </div>
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  ارزش
                </div>
                <div>
                  {value
                    ? `${toSeperatedNum(toPersianNum(value))} تومان`
                    : "وارد نشده‌است"}
                </div>
              </div>
            </div>
          </div>

          {loading_description ? (
            <div className="desc my-3 mx-3 mx-lg-0 px-2 py-3 text-dark">
              {loading_description ? loading_description : "شرح وارد نشده‌است"}
            </div>
          ) : null}
          <div className="left-badge m-3 d-lg-block d-none">
            <img
              // src={logo}
              alt=""
            />
            <span>بارنت | سامانه‌‌ حمل توافقی بار</span>
          </div>
        </div>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {selectLoadBits &&
            selectLoadBits.map((bit, index) => (
              <BitsSingleStyled key={index}>
                <div className="d-flex align-items-center justify-content-between ">
                  <div className="d-flex">
                    {bit._driver_id.profile_img ? (
                      <UserProfileImage
                        src={`${SERVER_API}uploaded_profile_images/${bit._driver_id.profile_img}.jpg`}
                        alt="logo"
                      />
                    ) : (
                      <UserProfileImage src={UserProfileVector} alt="logo" />
                    )}

                    <UserInfoContainer>
                      <div style={{ fontSize: "12px" }}>
                        {bit._driver_id.firstname} {bit._driver_id.lastname}
                      </div>
                      <div style={{ fontSize: "10px" }}>
                        <span>
                          {bit._driver_id.drivervehicle.vehicle.v_name}
                        </span>
                        <span>
                          {" "}
                          {bit._driver_id.drivervehicle.vehicle_category.t_name}
                        </span>
                      </div>
                    </UserInfoContainer>
                  </div>
                  <div style={{ width: "70px" }}>
                    {Rating(bit._driver_id.rank)}
                  </div>
                </div>

                <div className="bit__price">
                  <span>قیمت پیشنهادی:‌ </span>
                  <span>{toSeperatedNum(toPersianNum(bit.price))} </span>
                  <span>تومان</span>
                </div>

                <div className="mt-2 font-size--n1" style={{ opacity: "0.7" }}>
                  {bit.more_detail}
                </div>
              </BitsSingleStyled>
            ))}
        </Masonry>
      </Container>

      <div
        style={{
          position: "fixed",
          left: "24px",
          bottom: "22px",
        }}
      >
        <BackBtn />
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  currentLoad: selectCurrentLoad,
  selectLoadBits: selectLoadBits,
});

export default connect(mapStateToProps)(ReqInfo);
